<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>个人中心</span></div>
			<div class="center flex-between">
				<centerLeft :menu="-6"></centerLeft>
				<div class="center-right">
					<div class="order" v-if="step == 1">
						<div class="order-title">申请退货</div>
						<div class="ordergoods-table" v-if="info.goodsList.length > 0">
							<div class="ordergoods-table-title flex-center flex-between">
								<div class="ordergoods-table-title-title">商品信息</div>
								<div class="ordergoods-table-title-price">单价</div>
								<div class="ordergoods-table-title-price">数量</div>
								<div class="ordergoods-table-title-price">小计</div>
								<div class="ordergoods-table-title-price">操作</div>
							</div>
							<div class="ordergoods-table-body">
								<div v-for="item in info.goodsList" :key="item.id" class="ordergoods-table-item flex-between flex-center">
									<div class="ordergoods-table-item-goods flex-start flex-center">
										<img class="ordergoods-table-item-goods-image" :src="item.goodsSpecImage" mode="aspectFill"></img>
										<div class="ordergoods-table-item-goods-text">
											<div>{{item.goodsName}}</div>
											<div>{{item.goodsSpecName}}</div>
										</div>
										<div class="ordergoods-table-item-price">￥{{item.unitPrice}}</div>
										<div class="ordergoods-table-item-price">{{item.goodsNum}}</div> 
										<div class="ordergoods-table-item-value">￥{{item.totalPrice}}</div> 
										<div class="ordergoods-table-item-price" v-if="rufundInfo.id==item.id">已选择</div> 
										<div class="ordergoods-table-item-value" v-else @click.stop="rufundInfo = item">选择</div> 
									</div>
								</div>
							</div>
						</div>
						
						
						<div class="order-title">申请信息</div>
						<el-form :model="ruleForm" :rules="rules" ref="oneForm" label-position="left" class="refund-form">
						  <el-form-item label="退货商品：">
								<el-input v-model="rufundInfo.goodsName" :disabled="true" style="width: 280px;"></el-input>
						  </el-form-item>
						  <el-form-item label="提交数量：" prop="returnNum">
								<div class="set-num flex-start flex-center">
									<img src="@/assets/images/jian.png" @click="jian"/>
									<el-input-number style="width: 100px;" v-model="ruleForm.returnNum" @blur="changeNum" :controls="false" label="请输入购买数量"></el-input-number>
									<img src="@/assets/images/jia.png" @click="jia"/>
									<div class="">您最多可提交数量为{{rufundInfo.allowReturnNum}}个</div>
								</div>
						  </el-form-item>
						  <el-form-item label="退货原因：" prop="returnReason">
								<el-select v-model="ruleForm.returnReason" placeholder="请输入退货原因" style="width: 280px;">
								    <el-option v-for="item in reason" :key="item.id" :label="item.name" :value="item.name"></el-option>
								</el-select>
						  </el-form-item>
						  
						  
						  <el-form-item label="问题描述：" prop="problem">
						  		<el-input v-model="ruleForm.problem" type="textarea"  :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入问题描述，不得少于10个字。" style="width: 800px;"></el-input>
						  </el-form-item>
						  
						  
						  
						  <el-form-item label="上传凭证：" prop="image">
								<div class="image-list flex-start flex-center flex-wrap">
									<div class="image-list-item" v-for="(item, index) in ruleForm.image" :key="index">
										<img :src="item"/>
										<img src="@/assets/images/close.png" class="icon-close" @click="deleteImage(index)"/>
									</div>
									<el-upload :action="$apiBase + '/system/upload'" ref="uploadFile" :on-success="successImage" :limit="1">
										<div class="image-list-add">
											<img src="@/assets/images/add2.png"/>
											<div>选择图片</div>
										</div>
									</el-upload>
								</div>
								
								<div class="image-title">为了帮助您更好的解决问题，请上传图片</div>
								<div class="image-desc">最多可上传5张图片，每张图片大小不超过5M，支持bmp,gif,jpg,png,jpeg格式文件</div>
								<div class="image-desc" style="color: red;opacity: 1;font-size: 14px;line-height: 16px;">如货品已收到，请真实拍摄货品多角度照片并上传，平台需评估是否影响二次销售。</div>
								
						  </el-form-item>
						</el-form>
						
						<div class="bottom flex-between">
							<div class="bottom-left">
								<div class="bottom-left-title flex-start flex-center">
									<img src="@/assets/images/notice.png"/>
									<div>温馨提示</div>
								</div>
								<div class="bottom-left-desc">· 商品寄回地址将在审核通过后以短信形式告知，或在申请记录中查询。</div>
								<div class="bottom-left-desc">· 提交服务单后，售后专员可能与您电话沟通，请保持手机畅通。</div>
								<div class="bottom-left-desc">· 退货处理成功后退款金额将原路返回到您的支持账户中;</div>
							</div>
							
							<el-button class="order-result-item-button" v-if="info.orderStatus > 0" :loading="isSUbmit" @click="submit">确定提交</el-button>
						</div>
					</div>
					
					
					<div class="order" v-if="step == 2">
						<div class="order-title">申请退货</div>
						
						<div class="order-success">
							<img src="@/assets/images/dui.png"/>
							<div class="order-success-title">提交成功</div>
							<div class="order-success-desc">售后专员可能与您电话沟通，请保持手机畅通</div>
							<div class="order-success-button" @click="toBack">返回</div>
						</div>
						<div class="bottom flex-midden">
							<div class="bottom-left">
								<div class="bottom-left-title flex-start flex-center">
									<img src="@/assets/images/notice.png"/>
									<div>温馨提示</div>
								</div>
								<div class="bottom-left-desc">· 商品寄回地址将在审核通过后以短信形式告知，或在申请记录中查询。</div>
								<div class="bottom-left-desc">· 提交服务单后，售后专员可能与您电话沟通，请保持手机畅通。</div>
								<div class="bottom-left-desc">· 退货处理成功后退款金额将原路返回到您的支持账户中;</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import {orderInfo,updateOrderAddress,updateOrderStatus,createReturn,afterSalesReason} from "@/api/user"
export default {
	name: 'index',
	components:{
		centerLeft
	},
	data(){
		return {
			info:{goodsList:[],expressList:[]},
			id:0,
			show:false,
			rufundInfo:{},
			ruleForm:{
				returnNum:1,
				returnReason:"",
				problem:"",
				image:[]
			},
			rules:{
				returnNum:[{ required: true, message: '请输入退货数量', trigger: 'blur' }],
				returnReason:[{ required: true, message: '请选择退货原因', trigger: 'blur' }],
				problem:[{ required: true, message: '请输入问题描述', trigger: 'blur' }],
				image:[{ required: true, message: '请输入上传凭证', trigger: 'blur' }],
			},
			isSUbmit:false,
			step:1,
			reason:[]
		}
	},
	mounted() {
			this.id = this.$route.query.id || 0;
			afterSalesReason().then(res=>{
				this.reason = res.data;
			})
			this.getInfo();
	},
	methods:{
		getInfo(){
			orderInfo({orderId:this.id}).then(res=>{
				if(res.code == 1000){
					this.info = res.data;
					this.rufundInfo = res.data.goodsList[0];
					this.show = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		jian(){
			if(this.ruleForm.returnNum == 1){
				this.ruleForm.returnNum = 1;
			}else{
				this.ruleForm.returnNum--;
			}
		},
		jia(){
			if(this.ruleForm.returnNum >= this.rufundInfo.allowReturnNum){
				this.ruleForm.returnNum = this.rufundInfo.allowReturnNum;
			}else{
				this.ruleForm.returnNum++;
			}
		},
		changeNum(e){
			if(this.ruleForm.returnNum >= this.rufundInfo.allowReturnNum){
				this.ruleForm.returnNum = this.rufundInfo.allowReturnNum;
				this.$message.error("不能超过最大数量");
			}
			if(this.num < 1){
				this.num = 1;
			}
		},
		successImage(e){
			if(e.code == 1000){
				this.ruleForm.image.push(e.data);
			}
			this.$refs.uploadFile.clearFiles();
		},
		deleteImage(index){
			this.ruleForm.image.splice(index, 1);
		},
		toBack(){
			window.history.go(-1);
		},
		submit(){
			this.$refs['oneForm'].validate((valid) => {
				if (valid) {
					this.isSUbmit = true;
					createReturn({
						orderId:this.rufundInfo.orderId,//订单ID
						orderGoodsId:this.rufundInfo.id,//订单商品ID
						returnNum:this.ruleForm.returnNum,//退货数量
						returnReason:this.ruleForm.returnReason,//退货原因
						problem:this.ruleForm.problem,//问题描述
						image:this.ruleForm.image.join(","),//问题描述
					}).then(res=>{
						if(res.code == 1000){
							this.step = 2;
						}else{
							this.isSUbmit = false;
							return this.$message.error(res.message);
						}
					})
				} else {
					return false;
				}
			});
			
		}
	}
	
}
</script>

<style lang="scss" scoped>
	
	
	.order-success{
		text-align: center;
		padding-top: 160px;
		padding-bottom: 50px;
		img{
			width: 64px;
			height: 64px;
		}
		.order-success-title{
			font-size: 18px;
			line-height: 24px;
			color: #070B13;
			margin-top: 20px;
		}
		.order-success-desc{
			opacity: 0.6;
			font-size: 14px;
			line-height: 24px;
			text-align: center;
			color: #070B13;
			margin-top: 8px;
		}
		.order-success-button{
			width: 260px;
			height: 46px;
			border: 1px solid rgba(233, 26, 18, 0.1);
			font-size: 16px;
			font-weight: 500;
			line-height: 46px;
			text-align: center;
			color: #070B13;
			margin: 20px auto 0px;
			cursor: pointer;
		}
	}
	.bottom{
		margin-top:20px;
		.bottom-left{
			.bottom-left-title{
				img{
					width: 20px;
					height: 20px;
					margin-right: 8px;
				}
				div{
					opacity: 0.6;
					font-size: 16px;
					line-height: 24px;
					color: #070B13;
				}
			}
			.bottom-left-desc{
				opacity: 0.6;
				font-size: 16px;
				line-height: 24px;
				color: #070B13;
				margin-left: 28px;
			}
		}
		
		.order-result-item-button{
			width: 240px;
			height: 56px;
			background: #E91A12;
			font-size: 20px;
			font-weight: 500;
			letter-spacing: 0em;
			text-align: center;
			color: #FFFFFF;
		}
	}
	.image-title{
		font-size: 12px;
		line-height: 16px;
		color: #070B13;
		margin-left: 100px;
	}
	.image-desc{
		opacity: 0.4;
		font-size: 12px;
		line-height: 16px;
		color: #070B13;
		margin-left: 100px;
		margin-top: 8px;
	}
	.image-list{
		.image-list-add{
			width: 106px;
			height: 106px;
			border: 1px dashed rgba(0, 0, 0, 0.4);
			padding: 30px 0px 30px;
			box-sizing: border-box;
			text-align: center;
			margin: 0px 16px 16px 0px;
			img{
				width: 24px;
				height: 24px;
			}
			div{
				font-size: 12px;
				line-height: 16px;
				color: #070B13;
				margin-top: 8px;
			}
		}
		.image-list-item{
			width: 108px;
			height: 108px;
			position: relative;
			margin: 0px 16px 16px 0px;
			img{
				width: 108px;
				height: 108px;
				object-fit: cover;
			}
			.icon-close{
				width: 16px;
				height: 16px;
				position: absolute;
				top: 0px;
				right: 0px;
			}
		}
	}
	.refund-form{
		width: 100%;
		border: 1px solid rgba(7, 11, 19, 0.1);
		box-sizing: border-box;
		padding: 20px;
		.set-num{
			img{
				 width: 24px;
				 height: 24px;
				 flex: 0 0 24px;
			}
			div{
				font-size: 16px;
				font-weight: 500;
				line-height: 40px;
				color: #060707;
				margin: 0px 20px;
				&:last-of-type{
					color: rgba(7, 11, 19, 0.6);
				}
			}
		}
	}
	
	.ordergoods-table-body{
		padding: 0px;
		.ordergoods-table-item{
			padding-left: 40px;
			padding-right: 40px;
			box-sizing: border-box;
			font-size: 14px;
		}
	}
	.order{
		width: 100%;
		background: #FFFFFF;
		box-sizing: border-box;
		.order-title{
			font-size: 16px;
			font-weight: 500;
			color: #070B13;
			line-height: 72px;
		}
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding:0px 40px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
	
	@import url("../assets/order.scss");
</style>
